import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { Facilitator } from '@interfaces';
import { AppService } from '../../../../../services';
import { ConfigurationAreaService } from '../../../../configuration/configuration-area.service';
import { ConfigurationAcceleratorsService } from '../../configuration-accelerators.service';
import { getSetup } from './grid/get-setup';

@Component({
	selector: 'configuration-accelerators-program-facilitators-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './program-facilitators-view.part.html',
})
export class ConfigurationProgramFacilitatorsViewPart {

	private readonly util = inject(UtilityService);
	private readonly app = inject(AppService);
	private readonly areaService = inject(ConfigurationAreaService);
	private readonly pageService = inject(ConfigurationAcceleratorsService);

	public setup = getSetup(this.util, this.app);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public facilitators = computed(() => {
		const accelerators = this.areaService.configurationData()?.accelerators;
		if (!accelerators) return [];

		// map of facilators with faciliatorId as key from trimester accelerators
		const facilitatorsMap = accelerators.reduce((map, acc) => {
			const key = acc.facilitatorStaffId;

			if (!map[key]) {
				map[key] = {
					facilitatorId: key,
					accelerators: acc.name,
					updatedUTC: Date.now()
				};
			} else {
				map[key].accelerators += `, ${acc.name}`;
			}

			return map;

		}, {} as Record<number, Facilitator>);

		return Object.values(facilitatorsMap);
	});
}